var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7388 5.5714L4.34203 12.9682L3.33337 16.6666L7.03177 15.6579L14.4286 8.26115M11.7388 5.5714L13.4199 3.89032C13.5965 3.7137 13.8062 3.57361 14.0369 3.47803C14.2677 3.38245 14.515 3.33325 14.7648 3.33325C15.0145 3.33325 15.2619 3.38245 15.4926 3.47803C15.7234 3.57361 15.933 3.7137 16.1096 3.89032C16.2863 4.06693 16.4264 4.27659 16.5219 4.50735C16.6175 4.7381 16.6667 4.98542 16.6667 5.23519C16.6667 5.48495 16.6175 5.73227 16.5219 5.96302C16.4264 6.19378 16.2863 6.40345 16.1096 6.58006L14.4286 8.26115M11.7388 5.5714L14.4286 8.26115",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5419c2e2703ca43b171dd4a22a95d292.svg";
export { ForwardRef as ReactComponent };